module.exports = "/_assets/images/branding/corval-logo-monocolor-blue-hex.svg";